import { render, staticRenderFns } from "./selectsInput.vue?vue&type=template&id=40ecb55e&scoped=true"
import script from "./selectsInput.vue?vue&type=script&lang=js"
export * from "./selectsInput.vue?vue&type=script&lang=js"
import style0 from "./selectsInput.vue?vue&type=style&index=0&id=40ecb55e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ecb55e",
  null
  
)

export default component.exports